import React from 'react'

import { Box } from '@material-ui/core'

import useStyles from './styles'

const isYouTube = (url) =>
  url?.includes('youtube.com') || url?.includes('youtu.be')

const isVimeo = (url) => url?.includes('vimeo.com')

// https://www.youtube-nocookie.com/embed/XRJu-G6nFAg?si=EHyxeQc72VFGk20a"

const getYouTubeEmbedUrl = (url) => {
  if (!url) return null
  // already an embed URL
  const embedMatch = url.match(/youtube\.com\/embed\/([^?&\s]+)/)
  if (embedMatch)
    return `https://www.youtube-nocookie.com/embed/${embedMatch[1]}`
  // shorts
  const shortsMatch = url.match(/youtube\.com\/shorts\/([^?&\s]+)/)
  if (shortsMatch)
    return `https://www.youtube-nocookie.com/embed/${shortsMatch[1]}`
  // standard watch?v= and youtu.be/
  const videoId = url.match(/(?:v=|youtu\.be\/)([^?&\s]+)/)?.[1]
  return videoId ? `https://www.youtube-nocookie.com/embed/${videoId}` : null
}

const getVimeoEmbedUrl = (url) => {
  if (!url) return null
  // already a player URL
  const playerMatch = url.match(/player\.vimeo\.com\/video\/(\d+)/)
  if (playerMatch) return `https://player.vimeo.com/video/${playerMatch[1]}`
  // standard vimeo.com/ID or vimeo.com/ID/hash
  const videoId = url.match(/vimeo\.com\/(\d+)/)?.[1]
  return videoId ? `https://player.vimeo.com/video/${videoId}` : null
}

const LessonPlayer = ({ url }) => {
  const classes = useStyles()

  if (!url) return null

  if (isYouTube(url)) {
    const embedUrl = getYouTubeEmbedUrl(url)
    if (!embedUrl) return null
    return (
      <Box className={classes.wrapper}>
        <iframe
          src={embedUrl}
          className={classes.iframe}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Aula"
        />
      </Box>
    )
  }

  if (isVimeo(url)) {
    const embedUrl = getVimeoEmbedUrl(url)
    if (!embedUrl) return null
    return (
      <Box className={classes.wrapper}>
        <iframe
          src={embedUrl}
          className={classes.iframe}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="Aula"
        />
      </Box>
    )
  }

  return (
    <Box className={classes.wrapper}>
      <video src={url} controls className={classes.video} />
    </Box>
  )
}

export default LessonPlayer
